module.exports = "<svg \n\tclass=\"cxSpinner\"\n\t[style.width]=\"cxDiameter\"\n\t[style.height]=\"cxDiameter\"\n\tviewBox=\"0 0 100 100\">\n\t\t<svg:circle \n\t\t\tclass=\"cxSpinner-outline\"\n\t\t\tcx=\"50\"\n\t\t\tcy=\"50\"\n\t\t\t[attr.stroke-width]=\"outerLineWeight\"\n\t\t\t[attr.r]=\"50 - offset\">\n\t\t</svg:circle>\n\t\t<svg:path \n\t\t\tclass=\"cxSpinner-arc\"\n\t\t\t[attr.stroke-width]=\"innerLineWeight\"\n\t\t\t[attr.d]=\"d\">\n\t\t</svg:path>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/ui/src/app/directives/wait/spinner.directive.html
// module id = 1653
// module chunks = 2